module.exports = __webpack_public_path__ + "static/logo-v5-optimised-394b5ed89ee18a5b6ad9782c3dbd0e62.svg";